import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, SelectMenu, toast } from '@livable/saas-react-components';
import { Grid, MenuItem, Paper, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
import { createAccountSchema, createAccountValues } from 'src/utils/formValidation/Admin/CreateAccount';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { softwareList } from 'src/utils/company';
import { translate } from 'src/utils/translator';
import InputMask from 'react-input-mask';
import { observer } from 'mobx-react-lite';
export const ModalForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    externalTrigger = _ref.externalTrigger;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    handleStartValidate = _useState4[0],
    setHandleStartValidate = _useState4[1];
  const _useState5 = useState('no'),
    _useState6 = _slicedToArray(_useState5, 2),
    additionalSoftwareIsUsed = _useState6[0],
    setAdditionalSoftwareIsUsed = _useState6[1];
  const handleAdditionalSoftwareIsUsedChange = event => {
    if (event.target.value) setAdditionalSoftwareIsUsed(event.target.value);
  };
  const formik = useFormik({
    initialValues: createAccountValues,
    validationSchema: createAccountSchema,
    onSubmit: async () => {
      setHandleStartValidate(true);
    }
  });
  const handleStartSubmitting = async resultId => {
    var _formik$values$termsA;
    setIsLoading(true);
    const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
    const data = {
      firstName: formik.values.firstName,
      lastName: formik.values.lastName,
      email: formik.values.email,
      phone: "".concat(phoneCode).concat(formik.values.phone),
      termsAndConditions: (_formik$values$termsA = formik.values.termsAndConditions) !== null && _formik$values$termsA !== void 0 ? _formik$values$termsA : true,
      companyName: formik.values.companyName,
      postalAddress: formik.values.postalAddress,
      unitsProjected: formik.values.unitsProjected,
      website: formik.values.website,
      specifySoftware: formik.values.specifySoftware,
      propertyManagementSoftware: formik.values.propertyManagementSoftware,
      addressId: resultId
    };
    await formik.setFieldValue('termsAndConditions', true);
    try {
      const createPMAccountResp = await store.admin.createPMAccountAsync.run(_objectSpread(_objectSpread({}, beforeSubmitDataValidation(data)), {}, {
        password: 'Welcome@123'
      }));
      if (createPMAccountResp !== null && createPMAccountResp !== void 0 && createPMAccountResp.isSuccessful) {
        const companyData = Object.assign({}, data);
        delete companyData.email;
        delete companyData.phone;
        delete companyData.password;
        const createCompanyResp = await store.admin.createCompanyAsync.run(_objectSpread({
          accountId: createPMAccountResp.response
        }, beforeSubmitDataValidation(_objectSpread(_objectSpread({}, companyData), {}, {
          name: data.companyName,
          accountHolderEmail: data.email,
          accountHolderPhone: data.phone,
          companyType: 'IndependentRentalOwner'
        }))));
        if (createCompanyResp !== null && createCompanyResp !== void 0 && createCompanyResp.isSuccessful) {
          if (externalTrigger) externalTrigger();
          handleModalClose();
        }
      }
    } catch (e) {
      console.log('e', e);
      toast('error', e);
    }
    setIsLoading(false);
  };
  return /*#__PURE__*/React.createElement("form", {
    id: "create-account",
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.admin.createCompanyAsync.inProgress || store.admin.createPMAccountAsync.inProgress || store.address.addNewAddressAsync.inProgress || store.address.updateAddressAsync.inProgress
  }), /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, t('admin_page.pm_details')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: formik.values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(t(formik.errors.firstName, {
      field: t('general.first_name')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.last_name'),
    variant: "outlined",
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    value: formik.values.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(t(formik.errors.lastName, {
      field: t('general.last_name')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "email",
    name: "email",
    variant: "outlined",
    label: t('general.email_address'),
    value: formik.values.email,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.touched.email && translate(t(formik.errors.email, {
      field: t('general.email_address')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: formik.handleChange,
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(t(formik.errors.phone, {
      field: t('general.phone_number')
    }), t)
  })))))), /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "32px"
  }, t('company_details.title')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.enter_business_name'),
    variant: "outlined",
    fullWidth: true,
    id: "companyName",
    name: "companyName",
    value: formik.values.companyName,
    onBlur: formik.handleBlur,
    onChange: formik.handleChange,
    error: formik.touched.companyName && Boolean(formik.errors.companyName),
    helperText: formik.touched.companyName && translate(t(formik.errors.companyName, {
      field: t('general.business_name')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    error: formik.touched.postalAddress && Boolean(formik.errors.postalAddress),
    helperText: formik.touched.postalAddress && translate(t(formik.errors.postalAddress, {
      field: t('company_details.corporate_postal_mailing_address')
    }), t),
    name: "postalAddress",
    validator: formik
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.company_website_optional'),
    variant: "outlined",
    fullWidth: true,
    id: "website",
    name: "website",
    value: formik.values.website,
    onBlur: formik.handleBlur,
    onChange: formik.handleChange,
    error: formik.touched.website && Boolean(formik.errors.website),
    helperText: formik.touched.website && translate(t(formik.errors.website, {
      field: t('company_details.company_website')
    }), t)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    type: "number",
    variant: "h4"
  }, t('admin_page.how_many_residential_units'))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.number_of_units_optional'),
    variant: "outlined",
    type: "number",
    fullWidth: true,
    id: "unitsProjected",
    name: "unitsProjected",
    value: formik.values.unitsProjected,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onBlur: formik.handleBlur,
    onChange: e => {
      if (!/^[1-9][0-9]*$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    error: formik.touched.unitsProjected && Boolean(formik.errors.unitsProjected),
    helperText: formik.touched.unitsProjected && translate(formik.errors.unitsProjected, t)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('admin_page.management_software'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flexContainer, " ").concat(classes.smSection)
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: additionalSoftwareIsUsed,
    onChange: handleAdditionalSoftwareIsUsedChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "no"
  }, t('general.no')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "yes"
  }, t('general.yes'))), additionalSoftwareIsUsed === 'yes' && /*#__PURE__*/React.createElement("div", {
    className: classes.inlineSelect
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "propertyManagementSoftware",
    name: "propertyManagementSoftware",
    value: formik.values.propertyManagementSoftware,
    label: t('general.please_select'),
    labelId: "software-selector-label",
    onChange: formik.handleChange,
    error: formik.touched.propertyManagementSoftware && Boolean(formik.errors.propertyManagementSoftware),
    helperText: formik.touched.propertyManagementSoftware && translate(t(formik.errors.propertyManagementSoftware, {
      field: t('company_details.property_management_software')
    }), t)
  }, softwareList.map(software => /*#__PURE__*/React.createElement(MenuItem, {
    value: software,
    key: software
  }, software)), /*#__PURE__*/React.createElement(MenuItem, {
    value: "other"
  }, t('general.other')))), additionalSoftwareIsUsed === 'yes' && formik.values.propertyManagementSoftware === 'other' && /*#__PURE__*/React.createElement(TextField, {
    label: t('general.specify_optional'),
    variant: "outlined",
    fullWidth: true,
    id: "specifySoftware",
    name: "specifySoftware",
    value: formik.values.specifySoftware,
    onBlur: formik.handleBlur,
    onChange: formik.handleChange,
    error: formik.touched.specifySoftware && Boolean(formik.errors.specifySoftware),
    helperText: formik.touched.specifySoftware && translate(formik.errors.specifySoftware, t)
  }))));
});